import { TeamInfo } from "./team.model";

export class SaleTeamInfo {
  SaleTeams: TeamInfo[] = [];
  SaleTeamDetails: SaleTeamManagementsInfo[] = [];
  TotalBudget: number;
}

export class SaleTeamDetailInfo {
  TeamCode: string
  TeamName: string
  TeamColor: string
  TeamTotalDeal: number
  SaleTeamDetails: SaleTeamManagementsInfo[]
  StartDate: string
  EndDate: string

}

export class SaleTeamManagementsInfo {
  TeamId: number
  TeamCode: string
  TeamName: string
  TeamColor: string
  FlagDelete: string
  CreateDate: string
  CreateBy: string
  CreateByFullName: string
  UpdateDate: string
  UpdateBy: string

  EmployeeCode: string
  EmpName: string
  ProjectSaleID: number
  ProjectSaleCloseDealCreateDate: string
  ProjectSaleCode: string
  ProjectSaleName: string
  ProjectSaleActualPrice: number
  CompanyFlagNew: string
}
